module.exports = __webpack_public_path__ + "static/international_top_img@2x-b782909aa761ee358e66df59e9abb5e1.png";